module.exports = "<h3 [translate]=\"'TITLES.home'\"></h3>"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/home/home.component.html
// module id = ../../../../../src/app/pages/cerba/pages/home/home.component.html
// module chunks = 0